/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Direct_HeadingInputs */

const en_home_direct_heading = /** @type {(inputs: Home_Direct_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One less layer between you and your stay.`)
};

/**
* | output |
* | --- |
* | "One less layer between you and your stay." |
*
* @param {Home_Direct_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_direct_heading = /** @type {((inputs?: Home_Direct_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Direct_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_direct_heading(inputs)
});